import {Injectable} from '@angular/core';
import {DxDataGridComponent, DxFileUploaderComponent, DxPopupComponent, DxTreeListComponent} from 'devextreme-angular';
import {environment} from "../../environments/environment";
import CustomStore from 'devextreme/data/custom_store';
import * as _ from 'lodash';
import {UrlObj} from "../models/other/UrlObj";
import {DataService} from "./data.service";
import {CookieService} from "ngx-cookie-service";
import * as $ from 'jquery';
import {Router} from "@angular/router";
import {ServerService} from "./server.service";
import {DialogService} from "../components/generics/dialog/dialog.service";
import {ToolbarItem} from "devextreme/ui/data_grid";
import DevExpress from "devextreme";
import moment from "moment";
import {UploadHttpMethod} from "devextreme/ui/file_uploader";

class CustomFilter {
   key?:string;
   value?:string;
}

export class DataSourceOpt {
   byKeyUrl?:string;
   class?:any;
   remoteOperations?:boolean;
   requireTotalCount?:boolean;
   filter?:any;
   key?:string;
   extra?:any;
   exclude?:any;
   extraFilter?:CustomFilter[] = [];
   dxSearchValueKeys?: string
   update?(key:any, values:any):any;
   // delete?(key):any;
   insert?(data:any):any;
   remove?(key:any):any;
   onLoaded?: (rawData:{data:any[], initialCount: number, totalCount: number, summary:any}) => any;
}

@Injectable({
   providedIn: 'root'
})
export class DxService {

   public offsetHeight = 100;

   constructor(private dataSrv:DataService,
               private router:Router,
               private alertSrv:DialogService,
               private apiSrv:ServerService,
               private cookieSrv:CookieService) { }

   public fixGridLayout(grid?: DxDataGridComponent | null, delays: number[] = [0, 120, 250]) {
      if (!grid?.instance) return;

      delays.forEach(delay => {
         setTimeout(() => {
            try {
               grid.instance.updateDimensions();
               grid.instance.repaint();
            } catch (err) {
               console.warn('[fixGridLayout] impossibile aggiornare la grid', err);
            }
         }, delay);
      });
   }

   // region Toolbar button
   public getStdToolbarButton(opt:{
      text?: string,
      icon?: string,
      onClick?: () => any,
      hint?: string,
      location?: "after" | "before",
      class?: string,
      name: string} = {name: "btn"}
   ): ToolbarItem | DevExpress.ui.dxTreeList.dxTreeListToolbar{
      if(!opt.location) opt.location= "after"
      if(!opt.hint) opt.hint = opt.text
      let c = `btn-grd-toolbar ${opt.class}`
      return {
         widget: 'dxButton',
         options: {
            hint: opt.hint,
            icon: opt.icon,
            onClick: opt.onClick,
            text:opt.text,
            elementAttr: {"class": c}
         },
         locateInMenu: "auto",
         location: opt.location,
         name: opt.name,
         // text: opt.text
      }
   }

   public addToolbarItem(toolbarItems:any, grid:DxDataGridComponent, name:string, hint:string,
                         icon:string | undefined, text:string, onClick:()=>void)
   {
      if(!_.find(toolbarItems, {name:name})){
         // Adds a new item
         toolbarItems.push({
            widget: 'dxButton',
            options: {
               hint: hint,
               icon: icon,
               onClick: onClick,
               text:text,
               elementAttr: {"class": "btn-grd-toolbar"}
            },
            locateInMenu: "auto",
            location: 'after',
            name: name
         });
      }
   }

   public addToolbarItem2(toolbarItems:any, opt:{
      name:string, hint?: string, cssClass?:string, icon?:string, text:string, onClick: ()=>any,
      location?: string
   })
   {
      /**
       * this.grd.onToolbarPreparing.subscribe(data=>{
       */
      if(!opt.location) opt.location = 'after'
      // name, cssClass, hint, icon, text, onClick
      if(!_.find(toolbarItems, {name:opt.name})){
         // Adds a new item
         toolbarItems.push({
            widget: 'dxButton',
            options: {
               // cssClass:opt.cssClass,
               hint: opt.hint,
               icon: opt.icon,
               onClick: opt.onClick,
               text:opt.text,
               elementAttr:{
                  // class:opt.cssClass
               }
            },
            locateInMenu: "auto",
            location: opt.location,
            name: name
         });
      }
      return toolbarItems
   }
   // endregion Toolbar button

   public initGrid(grid: DxDataGridComponent | undefined,
                   options:{
                      simple?:boolean,
                      rowHeight?:number,
                      columnChooser?:boolean,
                      fitHeight?:boolean,
                      showRefresh?:boolean,
                      showSearch?:boolean,
                      showAdd?:boolean,
                      btnAddText?:string,
                      showAddRow?:boolean,
                      remoteOperations?:boolean,
                      onClickNew?:() => any,
                      onClickRefresh?:() => any,
                      pageSize?:number,
                      paging?:boolean,
                      allowColumnResizing?:boolean,
                      columnAutoWidth?:boolean,
                      iconAddBtn?:string,
                      filterRow?:boolean}={},
                   url:string|null = null,
                   dataSrcOpt: DataSourceOpt = {}
   ){
      return new Promise(resolve => {

         if(options.simple == undefined) options.simple = false
         if(options.showRefresh == undefined) options.showRefresh = this.dataSrv.user.IsStaff
         if(options.paging == undefined) options.paging = true
         if(options.iconAddBtn == undefined) options.iconAddBtn = 'fal fa-plus'

         if(!grid){
            console.error("GRID is null!!!")
            return
         }

         grid.scrolling = {
            mode: "standard", // "standard" | "virtual" | "infinite" | "standard"
            useNative: true,
            scrollByContent: true,
            scrollByThumb: true,
            showScrollbar:"always"  // "onHover" // or "onClick" | "always" | "never"
         };

         if(!options.simple){
            grid.paging = {
               enabled:true,
               pageSize: options.pageSize || 20
            }

            grid.pager = {
               visible: false
            };

            if (options.paging) {
               this.initCarbonPager(grid, {
                  allowedPageSizes: [10, 20, 50, 100],
                  defaultPageSize: options.pageSize || 20
               });
            }

            grid.columnChooser = {
               enabled: false,
               mode: "select",
               title: "Mostra Colonne"
            }
            grid.searchPanel = {
               visible: true
            }
            grid.filterRow = {
               visible: true
            }
            grid.loadPanel = {
               enabled: true,
               // indicatorSrc: "https://js.devexpress.com/Content/data/loadingIcons/rolling.svg"
               indicatorSrc: "/assets/img/rolling.svg",
               // text: "ciao mondo"
            };
         }
         else{
            // simple
            grid.loadPanel = {
               enabled: false,
               indicatorSrc: "/assets/img/rolling.svg",
            };
         }

         grid.wordWrapEnabled = true;
         grid.showRowLines = true;
         grid.showBorders = true;
         grid.hoverStateEnabled = true;
         grid.allowColumnResizing = true
         grid.columnAutoWidth = true
         grid.columnResizingMode = "widget"
         grid.rowAlternationEnabled = false

         if(!options.paging){
            grid.paging = {
               enabled: false
            }
         }

         // grid.onContentReady.subscribe(e=>{
         //    let columnChooserView = e.component.getView("columnChooserView");
         //    if (columnChooserView._popupContainer) {
         //       columnChooserView._initializePopupContainer();
         //       columnChooserView.render();
         //       columnChooserView._popupContainer.option("position", { of: e.element, my: "right top", at: "right top", offset: "0 50"});
         //    }
         // })

         if(options.showRefresh){
            grid.onToolbarPreparing.subscribe(data=>{
               var toolbarItems = data.toolbarOptions.items;
               if(options.showRefresh){
                  if(!_.find(toolbarItems, {name:'refresh'})){
                     // Adds a progetto item
                     this.addToolbarItem(toolbarItems, grid, 'refresh', 'Aggiorna', 'fal fa-sync-alt','Aggiorna', () => {
                        if(options.onClickRefresh !== undefined){
                           options.onClickRefresh();
                        }else{
                           grid.instance.refresh();
                        }
                     })
                  }
               }
            })
         }

         if(options.showAdd){
            grid.onToolbarPreparing.subscribe(data=>{
               var toolbarItems = data.toolbarOptions.items;
               if(!_.find(toolbarItems, {name:'add'})){
                  // Adds a progetto item
                  this.addToolbarItem(toolbarItems, grid, 'add', 'Nuovo', options.iconAddBtn,options.btnAddText || 'Nuovo', () => {
                     // grid.instance.refresh();
                     if(options.onClickNew !== undefined){
                        options.onClickNew();
                     }else{
                        this.router.navigate([window.location.pathname + '/new']);
                     }
                  })
               }
            })
         }

         // bugfix soluzione grezza al problema della data
         let cols: DevExpress.ui.dxDataGridColumn[] = grid.columns.filter((c: any) => c.dataType == "datetime") as DevExpress.ui.dxDataGridColumn[]
         for (const col of cols) {
            col.calculateFilterExpression = (filterValue, selectedFilterOperation, target)=>{
               let m = moment(filterValue)
               return [col.dataField, selectedFilterOperation, m.toISOString()]
            }
         }
         // Mettere startDate quando si vuole visualizzare un date ma trattarlo come dateTime
         cols = grid.columns.filter((c: any) => c.dataType == "startDate") as DevExpress.ui.dxDataGridColumn[]
         for (const col of cols) {
            col.dataType = "date"
            col.calculateFilterExpression = (filterValue, selectedFilterOperation, target)=>{
               let m = moment(filterValue)
               return [col.dataField, selectedFilterOperation, m.startOf("day").toISOString()]
            }
         }
         // cols = grid.columns.filter((c: any) => c.dataType == "date") as DevExpress.ui.dxDataGridColumn[]
         // for (const col of cols) {
         //
         //    col.calculateFilterExpression = (filterValue, selectedFilterOperation, target)=>{
         //       let m = moment(filterValue)
         //       return [col.dataField, selectedFilterOperation, m.format("YYYY-MM-DD")]
         //    }
         // }

         setTimeout(()=>{
            if(url){
               this.gridCreateDataSource(url, grid, dataSrcOpt)
            }

            this.fixGridLayout(grid);

            resolve(null)
         },10)

      })
   }

   public initCarbonPager(
   grid: DxDataGridComponent,
   options: {
      allowedPageSizes: number[],
      defaultPageSize: number
   }
): void {
   const anyGrid = grid as any;

   if (anyGrid.__carbonPagerInitialized) {
      return;
   }

   anyGrid.__carbonPagerInitialized = true;
   anyGrid.__carbonPagerOptions = options;

   grid.onContentReady.subscribe(() => {
      this.renderCarbonPager(grid);
   });

   grid.onOptionChanged.subscribe((e: any) => {
      if (
         e.fullName === 'paging.pageIndex' ||
         e.fullName === 'paging.pageSize'
      ) {
         setTimeout(() => this.renderCarbonPager(grid));
      }
   });

   setTimeout(() => this.renderCarbonPager(grid));
}

private renderCarbonPager(grid: DxDataGridComponent): void {
   if (!grid?.instance) {
      return;
   }

   const anyGrid = grid as any;
   const options = anyGrid.__carbonPagerOptions || {
      allowedPageSizes: [10, 20, 50, 100],
      defaultPageSize: 20
   };

   const gridElement = this.getDxNativeElement(grid.instance.element());

   if (!gridElement) {
      return;
   }

   const instance: any = grid.instance;
   const dataSource = instance.getDataSource ? instance.getDataSource() : null;

   let totalItems = 0;

   try {
      totalItems = dataSource && dataSource.totalCount
         ? Number(dataSource.totalCount())
         : 0;
   } catch {
      totalItems = 0;
   }

   if (!Number.isFinite(totalItems) || totalItems < 0) {
      totalItems = 0;
   }

   const pageSize = Number(instance.pageSize ? instance.pageSize() : options.defaultPageSize) || options.defaultPageSize;
   const pageIndex = Number(instance.pageIndex ? instance.pageIndex() : 0) || 0;

   let pageCount = 1;

   try {
      pageCount = instance.pageCount ? Number(instance.pageCount()) : Math.ceil(totalItems / pageSize);
   } catch {
      pageCount = Math.ceil(totalItems / pageSize);
   }

   if (!Number.isFinite(pageCount) || pageCount < 1) {
      pageCount = 1;
   }

   const currentPage = Math.min(pageIndex + 1, pageCount);
   const fromItem = totalItems === 0 ? 0 : pageIndex * pageSize + 1;
   const toItem = totalItems === 0 ? 0 : Math.min((pageIndex + 1) * pageSize, totalItems);

   let pager: HTMLElement | null = null;

const nextElement = gridElement.nextElementSibling;

if (
   nextElement instanceof HTMLElement &&
   nextElement.classList.contains('zent-carbon-pagination')
) {
   pager = nextElement;
}

if (!pager) {
   pager = document.createElement('div');
   pager.className = 'zent-carbon-pagination';
   gridElement.insertAdjacentElement('afterend', pager);
}

   const pageSizeOptions = options.allowedPageSizes
      .map((size: number) => {
         const selected = size === pageSize ? 'selected' : '';
         return `<option value="${size}" ${selected}>${size}</option>`;
      })
      .join('');

   const pageLabel = pageCount === 1 ? 'pagina' : 'pagine';

   const pageOptions = Array.from({ length: pageCount }, (_, i) => {
      const page = i + 1;
      const selected = page === currentPage ? 'selected' : '';
      return `<option value="${page}" ${selected}>${page}</option>`;
   }).join('');

   const previousDisabled = currentPage <= 1 ? 'disabled' : '';
   const nextDisabled = currentPage >= pageCount ? 'disabled' : '';
   const pageSelectDisabled = totalItems === 0 ? 'disabled' : '';

   pager.innerHTML = `
      <div class="zent-carbon-pagination__left">
         <div class="zent-carbon-pagination__page-size-group">
            <label class="zent-carbon-pagination__text">
               Elementi per pagina:
            </label>

            <div class="zent-carbon-select zent-carbon-select--page-size">
               <select class="zent-carbon-select__input" data-carbon-page-size aria-label="Elementi per pagina">
                  ${pageSizeOptions}
               </select>
               <span class="zent-carbon-select__arrow"></span>
            </div>
         </div>

         <div class="zent-carbon-pagination__range">
            ${fromItem}–${toItem} di ${totalItems} elementi
         </div>
      </div>

      <div class="zent-carbon-pagination__right">
         <div class="zent-carbon-select zent-carbon-select--page-number">
            <select class="zent-carbon-select__input" data-carbon-page-index aria-label="Numero pagina" ${pageSelectDisabled}>
               ${pageOptions}
            </select>
            <span class="zent-carbon-select__arrow"></span>
         </div>

         <span class="zent-carbon-pagination__text">
            di ${pageCount} ${pageLabel}
         </span>

         <button class="zent-carbon-pagination__button"
                 type="button"
                 data-carbon-prev
                 aria-label="Pagina precedente"
                 ${previousDisabled}>
            <svg class="zent-carbon-pagination__icon" width="20" height="20" viewBox="0 0 32 32" aria-hidden="true">
               <path d="M19 23L11 16 19 9 19 23z"></path>
            </svg>
         </button>

         <button class="zent-carbon-pagination__button"
                 type="button"
                 data-carbon-next
                 aria-label="Pagina successiva"
                 ${nextDisabled}>
            <svg class="zent-carbon-pagination__icon" width="20" height="20" viewBox="0 0 32 32" aria-hidden="true">
               <path d="M13 9L21 16 13 23 13 9z"></path>
            </svg>
         </button>
      </div>
   `;

   const pageSizeSelect = pager.querySelector('[data-carbon-page-size]') as HTMLSelectElement;
   const pageIndexSelect = pager.querySelector('[data-carbon-page-index]') as HTMLSelectElement;
   const previousButton = pager.querySelector('[data-carbon-prev]') as HTMLButtonElement;
   const nextButton = pager.querySelector('[data-carbon-next]') as HTMLButtonElement;

   pageSizeSelect.onchange = () => {
      const newPageSize = Number(pageSizeSelect.value);

      if (!Number.isFinite(newPageSize)) {
         return;
      }

      instance.pageSize(newPageSize);
      instance.pageIndex(0);
   };

   pageIndexSelect.onchange = () => {
      const newPage = Number(pageIndexSelect.value);

      if (!Number.isFinite(newPage)) {
         return;
      }

      instance.pageIndex(newPage - 1);
   };

   previousButton.onclick = () => {
      if (currentPage > 1) {
         instance.pageIndex(currentPage - 2);
      }
   };

   nextButton.onclick = () => {
      if (currentPage < pageCount) {
         instance.pageIndex(currentPage);
      }
   };
}

private getDxNativeElement(element: any): HTMLElement | null {
   if (!element) {
      return null;
   }

   if (element instanceof HTMLElement) {
      return element;
   }

   if (element[0] instanceof HTMLElement) {
      return element[0];
   }

   return null;
}

   public initUploadFile(uploader: DxFileUploaderComponent, opt:{
      onUploaded? : (res:any)=>any,
      onUploadStarted? : ()=>any,
      onUploadError? : ()=>any,
      uploadMethod?:UploadHttpMethod,
      uploadMode?:string,
   } = {}){

      if(!uploader){
         console.warn("[initUploadFile] uploader is null!!!")
         return
      }

      if(!opt.uploadMode) uploader.uploadMode = "useButtons"

      let csrftoken = this.cookieSrv.get("csrftoken");
      let headers:any = {}
      if(csrftoken){
         headers['X-CSRFToken'] = csrftoken
      }

      if(!opt.uploadMethod) opt.uploadMethod = "PUT"
      uploader.uploadMethod = opt.uploadMethod
      uploader.uploadHeaders = headers

      uploader.onUploaded.subscribe(res=>{
         uploader.instance.reset()
         if(opt.onUploaded){
            opt.onUploaded(res.request.response)
         }else{
            // this.msgSrv.swsuccess("File caricato con successo");
         }
      })

      uploader.onUploadError.subscribe(res=>{
         // let err = this.msgSrv.getError(res.error, "Impossibile caricare il file")
         // this.msgSrv.swerror("Impossibile caricare il file", res.error.response);
         if(opt.onUploadError) opt.onUploadError()
         uploader.instance.reset()
      })

      uploader.onUploadStarted.subscribe(res=>{
         if(opt.onUploadStarted) opt.onUploadStarted()
      })
   }

   public initPopup(dxPopup: DxPopupComponent){
      dxPopup.showTitle = true
      dxPopup.hideOnOutsideClick = true
      dxPopup.showCloseButton = true
   }

   public gridCreateDataSource(url: string,
                               grid: DxDataGridComponent | undefined,
                               opt: DataSourceOpt = {}){

      // https://jsfiddle.net/u3dfthrr/
      // && opt.key !== "all"

      if(opt.key == null) {
         opt.key = "id"
      }
      if(opt.class){
         opt.key = "data.id"
      }

      // if(grid && opt.insert){
      //    grid.columns.push({
      //       type: "buttons",
      //       buttons:[
      //          {name: "edit", cssClass: "btn-tbl w-auto mx-2", icon: "pi pi-pencil"},
      //          {name: "delete", cssClass: "btn-tbl w-auto mx-2", icon: "pi pi-trash"},
      //          {name: "save", cssClass: "btn-tbl w-auto mx-2", icon: "pi pi-save"},
      //          {name: "cancel", cssClass: "btn-tbl w-auto mx-2", icon: "pi pi-undo"}
      //       ]
      //    })
      // }


      if (grid && opt.insert) {
   grid.columns.push({
      type: "buttons",
      buttons: [
         {
            name: "edit",
            cssClass: "btn-tbl icon-modifica w-auto mx-2"
         },
         {
            name: "delete",
            cssClass: "btn-tbl-trash w-auto mx-2",
            icon: "fa-light fa-trash-can"
         },
         {
            name: "save",
            cssClass: "btn-tbl w-auto mx-2",
            icon: "fal fa-floppy-disk"
         },
         {
            name: "cancel",
            cssClass: "btn-tbl w-auto mx-2",
            icon: "fa-solid fa-xmark"
         }
      ]
   })
}

      if(opt.remoteOperations == null) opt.remoteOperations = true

      const optStore:any = {
         load: (loadOptions:any)=> {
            if(opt.class && loadOptions.sort){
               loadOptions.sort = _.map(loadOptions.sort, (d) => {
                  d.selector = d.selector.replace("data.", "")
                  return d
               })
            }
            if(opt.class && loadOptions.filter){
               loadOptions.filter = _.map(loadOptions.filter, (d) => {
                  if(_.isString(d)){
                     d = d.replace("data.", "")
                  }
                  if(_.isArray(d)){
                     d = _.map(d, d1=> {
                        if(_.isString(d1)){
                           d1 = d1.replace("data.", "")
                        }
                        return d1
                     })
                  }
                  return d
               })
            }
            if(opt.extra && Object.keys(opt.extra).length == 0) {opt.extra = null;}
            if(opt.filter && Object.keys(opt.filter).length == 0) {opt.filter = null;}

            return new Promise((resolve, reject) => {

               let data: any = {
                  extra: opt.extra ? JSON.stringify(opt.extra) : "{}",
                  filter: opt.filter ? JSON.stringify(opt.filter) : "{}",
                  dxSort: loadOptions.sort ? JSON.stringify(loadOptions.sort) : "{}",
                  dxFilter: loadOptions.filter ? JSON.stringify(loadOptions.filter) : "{}",
                  dxSearchExpr: loadOptions.searchExpr ? JSON.stringify(loadOptions.searchExpr) : "{}",
                  dxSearchOperation: loadOptions.searchOperation,
                  dxSkip : loadOptions.skip,
                  dxTake : loadOptions.take,
                  dxGrid : 1,
               };

               if(loadOptions.searchValue) data.dxSearchValue = loadOptions.searchValue

               if (opt && opt.extraFilter && opt.extraFilter.length){
                  for(let fil of opt.extraFilter){
                     let f:any = fil;
                     let tmp:any = {};
                     tmp[f.key] = fil.value;
                     Object.assign(data, tmp);
                  }
               }


               this.apiSrv.getAll(null, url, data, true)
                  .then((res: any)=>{
                     let data;
                     if(opt.class){
                        data = _.map(res.data, (d: any) => {
                           return new opt.class(d);
                        })
                     }else{
                        data = res.data
                     }

                     let resultData = {
                        data: data,
                        totalCount: res.totalCount || res.data.length,
                        initialCount: res.initialCount || res.data.length,
                        summary: res.summary || {}
                     }

                     // totalCount
                     if(res.totalCount != null){
                        resultData.totalCount = res.totalCount
                     }else {
                        // console.warn("totalCount mancante")
                        resultData.totalCount = res.data.length
                     }

                     // summary
                     if(res.summary != null){
                        resultData.summary = res.summary
                     }else {
                        // console.warn("summary mancante")
                        resultData.summary = {}
                     }

                     resolve(resultData)

                  })
                  .catch((err)=>{
                     if(err.status == 401 || err.status == 403){
                        window.location.replace(environment.loginPath)
                     }
                     let errMsg = this.alertSrv.getError(err, "Errore");
                     reject(errMsg.html)
                  })
            })
         },
         onLoading:(info:any)=>{
            if (grid){
               grid.instance.beginCustomLoading('')
            }
         },
         onLoaded:(rawData:any)=>{
            if (grid){grid.instance.endCustomLoading()}
            if (opt.onLoaded) {opt.onLoaded(rawData)}
         },
         remove: opt.remove,
         insert: opt.insert,
         update: opt.update,
      };

      if(opt.key != null){
         optStore.key = opt.key
         optStore.id = opt.key
      }

      if(!opt.remoteOperations){
         optStore.remoteOperations = false;
         optStore.requireTotalCount = false;
         if(grid) {grid.remoteOperations = false}
      }else{
         if(grid) grid.remoteOperations = true
      }

      const store = new CustomStore(optStore);

      let ris_store = {
         store: store
      }

      if(grid){
         grid.dataSource = ris_store
      }

      return ris_store

   }


   public treeListCreateDataSource(url: string, treeList: DxTreeListComponent | undefined, opt: DataSourceOpt = {}){

      // https://jsfiddle.net/u3dfthrr/
      // && opt.key !== "all"

      if(opt.key == null) opt.key = "id"

      if(opt.remoteOperations == null) opt.remoteOperations = true

      url = environment.urlServer + url

      const optStore:any = {
         key : opt.key,
         id : opt.key,
         load: (loadOptions:any)=> {

            if(opt.extra === {}) {opt.extra = null;}
            if(opt.filter === {}) {opt.filter = null;}

            var deferred = $.Deferred();

            let successData = {
               // extra: opt.extra ? JSON.stringify(opt.extra) : "{}",
               // filter: opt.filter ? JSON.stringify(opt.filter) : "{}",
               // dxSort: loadOptions.sort ? JSON.stringify(loadOptions.sort) : "{}",
               // dxFilter: loadOptions.filter ? JSON.stringify(loadOptions.filter) : "{}",
               // dxSearchExpr: loadOptions.searchExpr ? JSON.stringify(loadOptions.searchExpr) : "{}",
               // dxSearchOperation: loadOptions.searchOperation,
               // dxSearchValue: loadOptions.searchValue,
               // dxSkip : loadOptions.skip,
               // dxTake : loadOptions.take,
               // dxGrid : 1,
            };

            if (opt && opt.extraFilter && opt.extraFilter.length){
               for(let fil of opt.extraFilter){
                  let f:any = fil;
                  let tmp:any = {};
                  tmp[f.key] = fil.value;
                  Object.assign(successData, tmp);
               }
            }

            $.getJSON(url, successData).done((response) => {

               let ris:any = {
                  data: response.data,
                  totalCount: response.totalCount || response.data.length,
                  summary: response.summary || {}
               };

               // totalCount
               if(response.totalCount != null){
                  ris.totalCount = response.totalCount
               }else {
                  // console.warn("totalCount mancante")
                  ris.totalCount = response.data.length
               }

               // summary
               if(response.summary != null){
                  ris.summary = response.summary
               }else {
                  // console.warn("summary mancante")
                  ris.summary = null
               }

               deferred.resolve(ris);
            });

            return deferred.promise();

         },
         remove: opt.remove,
         insert: opt.insert,
         update: opt.update,
      };

      const store = new CustomStore(optStore);

      let ris_store = {
         store: store
      }

      if(treeList){
         treeList.dataSource = ris_store
         this.customizeActionButtons(treeList)
      }

      return ris_store
   }

   public autocompleteDataSource(url:string, opt:DataSourceOpt={}){

      // https://jsfiddle.net/u3dfthrr/

      url = environment.urlServer + url

      if(opt.key == null || opt.key !== "all"){
         opt.key = "id"
      }

      const optStore:any = {
         load: (loadOptions: { sort: any; filter: any; searchExpr: any; searchOperation: any; searchValue: any; skip: any; take: any; })=> {

            var deferred = $.Deferred();

            let args:any = {}

            if(opt.extra === {}) {opt.extra = null;}
            if(opt.filter === {}) {opt.filter = null;}

            let urlObj = new UrlObj(url)
            if(opt.extra) Object.assign(urlObj.queryParams, opt.extra);

            // if(opt.filter) urlObj.queryParams["filter"] = JSON.stringify(opt.filter);
            // if(opt.filter) args.filter = JSON.stringify(opt.filter) || "{}";

            if(loadOptions.sort) urlObj.queryParams["dxSort"] = loadOptions.sort;
            if(loadOptions.filter) urlObj.queryParams["dxFilter"] = loadOptions.filter;
            if(loadOptions.searchExpr) urlObj.queryParams["dxSearchExpr"] = loadOptions.searchExpr;
            if(loadOptions.searchOperation) urlObj.queryParams["dxSearchExpr"] = loadOptions.searchOperation;
            if(loadOptions.searchValue) urlObj.queryParams["dxSearchValue"] = loadOptions.searchValue;

            urlObj.queryParams["dxSkip"] = loadOptions.skip;
            urlObj.queryParams["dxTake"] = loadOptions.take;

            $.getJSON(urlObj.toString(),{
               filter: opt.filter ? JSON.stringify(opt.filter) : "{}",
               exclude: opt.exclude ? JSON.stringify(opt.exclude) : "{}"

            }).done( (response) =>{
               deferred.resolve({
                  data: response.data,
                  totalCount: response.totalCount || response.data.length
               });
            });
            //
            return deferred.promise();
            //     // }
            //
         },
         byKey:  (key:any) => {
            if(opt.byKeyUrl){
               return $.get(opt.byKeyUrl + '/' + key.toString());
            }else{
               return $.get(url + '/' + key.toString());
            }
         }
      };

      //
      // if(opt.key != null){
      //   optStore.key = opt.key
      // }
      //
      // if(!opt.remoteOperations){
      //   optStore.remoteOperations = false;
      //   optStore.requireTotalCount = false;
      //   if(grid) {grid.remoteOperations = false}
      // }

      const store = new CustomStore(optStore);

      return {
         store: store
      }
   }


//    public customizeActionButtons(el: DxDataGridComponent|DxTreeListComponent){
//    let c = "btn-tbl btn-trl-command"
//    el.columns.push({
//       type: "buttons",
//       buttons:[
//          {name: "cancel", cssClass:c},
//          {name: "add", cssClass:c, icon: "fal fa-plus fa-2x"},
//          {name: "delete", cssClass:c, icon: "fa-light fa-trash-can"},
//          {name: "edit", cssClass:c, icon: "fal fa-pencil-alt"},
//          {name: "save", cssClass:c, icon:"fal fa-floppy-disk"},
//          {name: "undelete", cssClass:c},
//       ]
//    })
// }

   public customizeActionButtons(el: DxDataGridComponent | DxTreeListComponent) {
   el.columns.push({
      type: "buttons",
      buttons: [
         {
            name: "cancel",
            cssClass: "btn-tbl btn-trl-command",
            icon: "fa-solid fa-xmark"
         },
         {
            name: "add",
            cssClass: "btn-tbl btn-trl-command",
            icon: "fa-solid fa-plus"
         },
         {
            name: "delete",
            cssClass: "btn-tbl-trash btn-trl-command",
            icon: "fa-light fa-trash-can"
         },
         {
            name: "edit",
            cssClass: "btn-tbl icon-modifica btn-trl-command"
         },
         {
            name: "save",
            cssClass: "btn-tbl btn-trl-command",
            icon: "fal fa-floppy-disk"
         },
         {
            name: "undelete",
            cssClass: "btn-tbl btn-trl-command",
            icon: "fa-light fa-rotate-left"
         }
      ]
   })
}

}


// columnMultiLang(param: any):any[] {
//    let ris:DevExpress.ui.dxDataGridColumn[] = []
//    for (const lang of this.dataSrv.langs) {
//       let tmp:any = {}
//       let allowEditing = param.allowEditing
//       if(allowEditing == null){
//          allowEditing = true
//       }
//       tmp["dataField"] = `${param.dataField}_${lang.data.code}`
//       tmp["caption"] = `${param.caption} [${lang.data.code?.toUpperCase()}]`
//       tmp["allowEditing"] = allowEditing
//       ris.push(tmp)
//    }
//    return ris;
// }
